<div class="public-registry-block" [ngClass]="{ 'public-registry-block-record': recordView }">
    <ng-container *ngIf="recordView; else fieldRows">
        <h4 *ngIf="recordView" class="public-registry-block__name mb-3">{{ _entry.name }}</h4>
        <table class="public-registry-block__table">
            <tbody>
                <tr
                    *ngFor="let field of (_entry.rows | hiddenFilterPipe: ignoreHideFilter)"
                    class="public-registry-block__row"
                >
                    <td class="public-registry-block__table_label">
                        <ng-template *ngTemplateOutlet="label; context: { $implicit: field }"> </ng-template>
                    </td>
                    <td class="public-registry-block__table_content">
                        <ng-template *ngTemplateOutlet="content; context: { $implicit: field }"> </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </ng-container>
    <ng-template #fieldRows>
        <div
            *ngFor="let field of (_entry.rows | hiddenFilterPipe: ignoreHideFilter)"
            class="public-registry-block__row"
        >
            <ng-template *ngTemplateOutlet="label; context: { $implicit: field }"> </ng-template>
            <ng-template *ngTemplateOutlet="content; context: { $implicit: field }"> </ng-template>
        </div>
    </ng-template>
    <ng-template #label let-field>
        <label>{{ field.name }}: </label>
    </ng-template>
    <ng-template #content let-field>
        <ng-container *ngIf="!field.type">
            <cm-display-html class="cm-display-html" [content]="field.value"></cm-display-html>
        </ng-container>
        <ng-container *ngIf="field.type" [ngSwitch]="field.type">
            <cm-attachments-popover
                *ngSwitchCase="'attachment'"
                class="public-registry-block__row-attachment"
                [attachments]="field.value"
            >
            </cm-attachments-popover>
        </ng-container>
    </ng-template>
    <button
        *ngIf="!hideDetailsBtn"
        class="btn btn-primary public-registry-block__row__button"
        (click)="viewDetailsClick.emit(_entry)"
    >
        View details
    </button>
</div>
